export default "__VITE_ASSET__137aa2b7__"